import Client from "./ApiClient";

const resource = "users";

const getUsers = (name, role, page = 1, perPage = 10) => {
  return Client.get(
    `${resource}?${name ? `name=${name}&` : ""}${
      role ? `role=${role}&` : ""
    }page=${page}&perPage=${perPage}`
  );
};

const profile = token => {
  Client.setHeader("Authorization", `Bearer ${token}`);
  return Client.get(`${resource}/profile`);
};

const getOne = userId => {
  return Client.get(`${resource}/${userId}`);
};

const create = data => {
  return Client.post(resource, data);
};

const update = (userId, data) => {
  return Client.put(`${resource}/${userId}`, data);
};

const deleteUser = userId => {
  return Client.delete(`${resource}/${userId}`);
};

const adminBookSlot = (psychologyId, slotId, userId) => {
  return Client.post(
    `${resource}/${psychologyId}/booking_slots/${slotId}/admin-book`,
    {
      userId
    }
  );
};

export default {
  getUsers,
  getOne,
  profile,
  create,
  update,
  deleteUser,
  adminBookSlot
};
